__webpack_require__.p = "/Color-Lights/";